var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDoubleQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10571_14087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.23047 10.4258V9.00781C5.23047 8.53125 5.30859 8.03516 5.46484 7.51953C5.62891 6.99609 5.86328 6.49609 6.16797 6.01953C6.47266 5.53516 6.83984 5.11719 7.26953 4.76562L8.5 5.62109C8.14062 6.13672 7.86328 6.66797 7.66797 7.21484C7.47266 7.75391 7.375 8.33984 7.375 8.97266V10.4258H5.23047ZM8.92188 10.4258V9.00781C8.92188 8.53125 9 8.03516 9.15625 7.51953C9.32031 6.99609 9.55469 6.49609 9.85938 6.01953C10.1641 5.53516 10.5312 5.11719 10.9609 4.76562L12.1914 5.62109C11.832 6.13672 11.5547 6.66797 11.3594 7.21484C11.1641 7.75391 11.0664 8.33984 11.0664 8.97266V10.4258H8.92188Z",
    fill: "#62626A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10571_14087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleQuotes);
export default __webpack_public_path__ + "static/media/icon-double-quotes.aa8c5f24fed7c1ba9015b054aa50d40a.svg";
export { ForwardRef as ReactComponent };